import { PAGE_NAME_TEMPLATE } from './constants';

/**
 * Замена PAGE_NAME_TEMPLATE в исходной строке на переданное значение.
 *
 * @kind helper
 * @param source - Исходная строка.
 * @param value — Строка для замены.
 * @returns Строка с подставленным значением вместо PAGE_NAME_TEMPLATE.
 */
export function replaceTemplate(source: string, value: string) {
    return source.split(PAGE_NAME_TEMPLATE).join(encodeURIComponent(JSON.stringify(value).slice(1, -1)));
}
